import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import "swiper/css";
// import download from "../assets/solution/Heliosen_DiTAP_Solution.pdf";

function DitapMAin({ getData }) {
  useEffect(() => {
    getData(
      "DiTAP",
      "3D 디지털 트윈의 의미를 시각화 하여 DiTAP의 아이덴티티를 상징적으로",
      "표현하여 시인성과 신뢰, 디지털 트윈 기술이 창조하는 새로운 세상을 의미합니다."
    );
  }, [getData]);

  const publicUrl = process.env.PUBLIC_URL;

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      {pc ? (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <div>
                  <h2 className="basic-title">DiTAP</h2>
                  <div className="basic-subtitle">
                    <p>디지털 트윈 서비스 개발에 최적화된 기능을 제공하고</p>
                    <p>
                      요구에 맞는 멀티플랫폼(WebGL, Unity) 솔루션을 제공합니다.
                    </p>
                  </div>
                </div>
                <p className="mark"></p>
              </div>

              <div>
                <p className="basic-banner ditap-main-banner"></p>
                <div className="ditap-main-desc">
                  <div className="ditap-main-left">
                    <h3 className="ditap-main-title">
                      <span>Digital Twin</span>
                      <span>Application</span>
                    </h3>
                    <a
                      href={`${publicUrl}/assets/solution/Heliosen_DiTAP_Solution.pdf`}
                      className="ditap-dwn-btn"
                      download
                    >
                      DiTAP 제품 소개서 다운로드
                    </a>
                  </div>
                  <div className="ditap-main-right">
                    <div className="ditap-main-cont">
                      <p>DiTAP은 디지털 트윈 시스템 구축을 위한 가장 편리한</p>
                      <p>솔루션입니다.</p>
                    </div>
                    <div className="ditap-sub-cont">
                      <p>
                        여러분의 3D 데이터를 디지털 트윈 세상에 보여주세요.
                        DiTAP은 다양한 공간정보를 변환하고
                      </p>
                      <p>배포해주며 어디서나 볼 수 있게 시각화 해줍니다.</p>
                    </div>
                    <div>
                      <ul className="ditap-main-desc-list">
                        <li className="ditap-main-desc-item">
                          <h4 className="ditap-main-desc-item-title">
                            BASE MAP 구축
                          </h4>
                          <div className="ditap-main-desc-item-cont">
                            <p>DEM, 정사영상 구축, 타일 서비스</p>
                          </div>
                        </li>
                        <li className="ditap-main-desc-item">
                          <h4 className="ditap-main-desc-item-title">
                            서비스 목적에 맞는 패키지 지원
                          </h4>
                          <div className="ditap-main-desc-item-cont">
                            <p>자산관리 서비스, 건설관리 서비스</p>
                            <p>(공장, 에너지 등 추가 확장 예정)</p>
                          </div>
                        </li>
                        <li className="ditap-main-desc-item">
                          <h4 className="ditap-main-desc-item-title">
                            BASE MAP 구축
                          </h4>
                          <div className="ditap-main-desc-item-cont">
                            <p>경량화, 타일화, 3Dtiles 생성 /고속 렌더링</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ditap-technology">
              <h2 className="basic-title">DiTAP 주요 기능</h2>
              <div className="basic-subtitle">
                <p>다양한 기술을 바탕으로 DiTAP은 고객에게</p>
                <p>최상의 서비스를 제공합니다.</p>
              </div>
              <div>
                <ul className="technology-list">
                  <li className="technology-item">
                    <span className="technology-img ditap-img1"></span>
                    <h2 className="technology-name">
                      고품질 BASEMAP 제공/서비스
                    </h2>
                    <p className="technology-subname">
                      (DEM 2.5m / 정사영상 25cm)
                    </p>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img2"></span>
                    <h2 className="technology-name">
                      3차원 대용량 데이터 서비스 지원
                    </h2>
                    <p className="technology-subname">(PointCloud, BIM)</p>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img3"></span>
                    <h2 className="technology-name">
                      시계열/멀티미디어 데이터 지원 가능
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img4"></span>
                    <h2 className="technology-name">
                      객체 단위 데이터 관리 가능
                    </h2>
                    <p className="technology-subname">
                      (객체별 고유 아이디 부여)
                    </p>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img5"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        가상의 논리적 객체(벽면, 조경구역 등)
                      </span>
                      <span className="basic-block">구축 지원</span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img6"></span>
                    <h2 className="technology-name">와이어프레임 기능</h2>
                    <p className="technology-subname">
                      (직관적 실내 자산관리 파악)
                    </p>
                  </li>
                </ul>
                <div className="technology-imgs">
                  <p className="technology-img1"></p>
                  <p className="technology-img2"></p>
                  <p className="technology-img3"></p>
                </div>
              </div>
            </div>

            <div className="ditap-technology technology-line">
              <h2 className="basic-title">DiTAP 기대 효과</h2>
              <div className="basic-subtitle">
                <p>DiTAP은 디지털 트윈 등 다양한 측면에서</p>
                <p>기대효과를 불러올 수 있습니다.</p>
              </div>
              <div>
                <ul className="technology-list">
                  <li className="technology-item">
                    <span className="technology-img ditap-img1"></span>
                    <h2 className="technology-name">
                      고품질 베이스맵 서비스가 가능
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img7"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        3차원 데이터가 지형에 묻히거나
                      </span>
                      <span className="basic-block">
                        공중에 뜰 확률이 현저히 낮음
                      </span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img8"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        3Dtiles 생성 시 외산 소프트웨어
                      </span>
                      <span className="basic-block">
                        사용할 필요 없음 → 비용 절감
                      </span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img9"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        패키지별 서비스 지원으로 필요한
                      </span>
                      <span className="basic-block">기능만 적용 가능</span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img10"></span>
                    <h2 className="technology-name">
                      3차원 데이터 대용량 서비스 가능
                    </h2>
                    <p className="technology-subname">
                      (국제표준 준수/대용 처리 → 전 세계 서비스 가능)
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="ditap-desc">
            <ul className="inner ditap-desc-list">
              <li className="ditap-desc-item">
                <div className="ditap-desc-img ditap-desc-am"></div>
                <div className="ditap-desc-cont-wrap">
                  <h3 className="ditap-desc-title">
                    <span className="basic-block">
                      DiTAP AM (ditap Twin Application -
                    </span>
                    <span className="basic-block">
                      Asset Management)은 디지털 트윈을 활용한
                    </span>
                    <span className="basic-block">
                      자산 관리 소프트웨어입니다.
                    </span>
                  </h3>
                  <div className="ditap-desc-cont">
                    <p>
                      고품질 베이스맵과 3차원 데이터 렌더링을 제공하고 객체 별
                      ID를 부여하여 객체 단위 자산 관리가 가능합니다. 웹 표준을
                      기반으로 하여 건물 자산 관리 기능을 수행합니다. 관리 기능
                      중 건축물 자산관리 모듈 제공(자산가치, 수익관리, 에너지
                      관리, 공간관리 등), 건축물 자산관리 모듈내 세부기능
                      제공(시가, 노후도, 면적당 에너지 사용량 등) 등이 있습니다.
                    </p>
                    <p>
                      DiTAP_AM은 4차 산업혁명 스마트시티와 관련된 공공 서비스,
                      시설물 관리 서비스, 건축 및 건설/ 플랜트 서비스, 건축물
                      관리 서비스, 에너지 관리 등 다양한 분야에서 활용이
                      가능합니다.
                    </p>
                  </div>
                </div>
              </li>
              <li className="ditap-desc-item">
                <div className="ditap-desc-cont-wrap">
                  <h3 className="ditap-desc-title">
                    <span className="basic-block">
                      DiTAP CM (ditap Twin Application -
                    </span>
                    <span className="basic-block">
                      Construction Management)은 디지털 트윈을 활용한 건설 관리
                      소프트웨어입니다.
                    </span>
                  </h3>
                  <div className="ditap-desc-cont">
                    <p>
                      드론 촬영 데이터, BIM, 설계도면 등 실제 건설 현장에서
                      수집되는 다양한 데이터를 디지털 트윈으로 제공하여 건설
                      공정 관리를 돕는 솔루션입니다.
                    </p>
                    <p>
                      설계 BIM과 현재 공사 중인 건축물의 현황 정보를 비교해 설계
                      오류를 최소화할 수 있습니다.
                    </p>
                  </div>
                </div>
                <div className="ditap-desc-img ditap-desc-cm"></div>
              </li>
            </ul>
          </div>
        </>
      ) : (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <h2 className="basic-title">DiTAP</h2>

                <p className="mark"></p>
              </div>
              <div className="basic-subtitle">
                <p>디지털 트윈 서비스 개발에 최적화된 기능을 제공하고</p>
                <p>요구에 맞는 멀티플랫폼(WebGL, Unity) 솔루션을 제공합니다.</p>
              </div>

              <div>
                <p className="basic-banner ditap-main-banner"></p>
                <div className="ditap-main-desc">
                  <div className="ditap-main-left">
                    <h3 className="ditap-main-title">
                      <span>Digital Twin</span>
                      <span>Application</span>
                    </h3>
                    <a
                      href={`${publicUrl}/assets/solution/Heliosen_DiTAP_Solution.pdf`}
                      download
                      className="ditap-dwn-btn"
                    >
                      DiTAP 제품 소개서 다운로드
                    </a>
                  </div>
                  <div className="ditap-main-right">
                    <div className="ditap-main-cont">
                      <p>DiTAP은 디지털 트윈 시스템 구축을 위한</p>
                      <p>가장 편리한 솔루션입니다.</p>
                    </div>
                    <div className="ditap-sub-cont">
                      <p>
                        여러분의 3D 데이터를 디지털 트윈 세상에 보여주세요.
                        DiTAP은 다양한 공간정보를 변환하고
                      </p>
                      <p>배포해주며 어디서나 볼 수 있게 시각화 해줍니다.</p>
                    </div>
                    <div>
                      <ul className="ditap-main-desc-list">
                        <li className="ditap-main-desc-item">
                          <h4 className="ditap-main-desc-item-title">
                            BASE MAP 구축
                          </h4>
                          <div className="ditap-main-desc-item-cont">
                            <p>DEM, 정사영상 구축, 타일 서비스</p>
                          </div>
                        </li>
                        <li className="ditap-main-desc-item">
                          <h4 className="ditap-main-desc-item-title">
                            서비스 목적에 맞는 패키지 지원
                          </h4>
                          <div className="ditap-main-desc-item-cont">
                            <p>자산관리 서비스, 건설관리 서비스</p>
                            <p>(공장, 에너지 등 추가 확장 예정)</p>
                          </div>
                        </li>
                        <li className="ditap-main-desc-item">
                          <h4 className="ditap-main-desc-item-title">
                            BASE MAP 구축
                          </h4>
                          <div className="ditap-main-desc-item-cont">
                            <p>경량화, 타일화, 3Dtiles 생성 /고속 렌더링</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ditap-technology">
              <h2 className="basic-title">DiTAP 주요 기능</h2>
              <div className="basic-subtitle">
                <p>다양한 기술을 바탕으로 DiTAP은 고객에게</p>
                <p>최상의 서비스를 제공합니다.</p>
              </div>
              <div>
                <ul className="technology-list">
                  <li className="technology-item">
                    <span className="technology-img ditap-img1"></span>
                    <h2 className="technology-name">
                      고품질 BASEMAP 제공/서비스
                    </h2>
                    <p className="technology-subname">
                      (DEM 2.5m / 정사영상 25cm)
                    </p>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img2"></span>
                    <h2 className="technology-name">
                      3차원 대용량 데이터 서비스 지원
                    </h2>
                    <p className="technology-subname">(PointCloud, BIM)</p>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img3"></span>
                    <h2 className="technology-name">
                      시계열/멀티미디어 데이터 지원 가능
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img4"></span>
                    <h2 className="technology-name">
                      객체 단위 데이터 관리 가능
                    </h2>
                    <p className="technology-subname">
                      (객체별 고유 아이디 부여)
                    </p>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img5"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        가상의 논리적 객체(벽면, 조경구역 등)
                      </span>
                      <span className="basic-block">구축 지원</span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img6"></span>
                    <h2 className="technology-name">와이어프레임 기능</h2>
                    <p className="technology-subname">
                      (직관적 실내 자산관리 파악)
                    </p>
                  </li>
                </ul>
                <div className="technology-imgs">
                  <p className="technology-img1"></p>
                  <p className="technology-img2"></p>
                  <p className="technology-img3"></p>
                </div>
              </div>
            </div>

            <div className="ditap-technology technology-line">
              <h2 className="basic-title">DiTAP 기대 효과</h2>
              <div className="basic-subtitle">
                <p>DiTAP은 디지털 트윈 등 다양한 측면에서</p>
                <p>기대효과를 불러올 수 있습니다.</p>
              </div>
              <div>
                <ul className="technology-list">
                  <li className="technology-item">
                    <span className="technology-img ditap-img1"></span>
                    <h2 className="technology-name">
                      고품질 베이스맵 서비스가 가능
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img7"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        3차원 데이터가 지형에 묻히거나
                      </span>
                      <span className="basic-block">
                        공중에 뜰 확률이 현저히 낮음
                      </span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img8"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        3Dtiles 생성 시 외산 소프트웨어
                      </span>
                      <span className="basic-block">
                        사용할 필요 없음 → 비용 절감
                      </span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img9"></span>
                    <h2 className="technology-name">
                      <span className="basic-block">
                        패키지별 서비스 지원으로 필요한
                      </span>
                      <span className="basic-block">기능만 적용 가능</span>
                    </h2>
                  </li>
                  <li className="technology-item">
                    <span className="technology-img ditap-img10"></span>
                    <h2 className="technology-name">
                      3차원 데이터 대용량 서비스 가능
                    </h2>
                    <p className="technology-subname">
                      (국제표준 준수/대용 처리 → 전 세계 서비스 가능)
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="ditap-desc">
            <ul className="ditap-desc-list">
              <li className="ditap-desc-item">
                <div className="ditap-desc-img ditap-desc-am"></div>
                <div className="ditap-desc-cont-wrap">
                  <h3 className="ditap-desc-title">
                    <span className="basic-block">
                      DiTAP AM (ditap Twin Application
                    </span>
                    <span className="basic-block">
                      - Asset Management)은 디지털 트윈을 활용한 자산 관리
                      소프트웨어입니다.
                    </span>
                  </h3>
                  <div className="ditap-desc-cont">
                    <p>
                      고품질 베이스맵과 3차원 데이터 렌더링을 제공하고 객체 별
                      ID를 부여하여 객체 단위 자산 관리가 가능합니다. 웹 표준을
                      기반으로 하여 건물 자산 관리 기능을 수행합니다. 관리 기능
                      중 건축물 자산관리 모듈 제공(자산가치, 수익관리, 에너지
                      관리, 공간관리 등), 건축물 자산관리 모듈내 세부기능
                      제공(시가, 노후도, 면적당 에너지 사용량 등) 등이 있습니다.
                    </p>
                    <p>
                      DiTAP_AM은 4차 산업혁명 스마트시티와 관련된 공공 서비스,
                      시설물 관리 서비스, 건축 및 건설/플랜트 서비스, 건축물
                      관리 서비스, 에너지 관리 등 다양한 분야에서 활용이
                      가능합니다.
                    </p>
                  </div>
                </div>
              </li>
              <li className="ditap-desc-item">
                <div className="ditap-desc-img ditap-desc-cm"></div>
                <div className="ditap-desc-cont-wrap">
                  <h3 className="ditap-desc-title">
                    <span className="basic-block">
                      DiTAP CM (ditap Twin Application
                    </span>
                    <span className="basic-block">
                      - Construction Management)은 디지털 트윈을 활용한 건설
                      관리 소프트웨어입니다.
                    </span>
                  </h3>
                  <div className="ditap-desc-cont">
                    <p>
                      드론 촬영 데이터, BIM, 설계도면 등 실제 건설 현장에서
                      수집되는 다양한 데이터를 디지털 트윈으로 제공하여 건설
                      공정 관리를 돕는 솔루션입니다.
                    </p>
                    <p>
                      설계 BIM과 현재 공사 중인 건축물의 현황 정보를 비교해 설계
                      오류를 최소화할 수 있습니다.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </>
      )}
    </>
  );
}

export default DitapMAin;
